import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=4f9411b2&"
import script from "./Content.js?vue&type=script&lang=js&"
export * from "./Content.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f9411b2')) {
      api.createRecord('4f9411b2', component.options)
    } else {
      api.reload('4f9411b2', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=4f9411b2&", function () {
      api.rerender('4f9411b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Content/Content.vue"
export default component.exports